import { createSelector } from 'reselect';
import { NAME } from './constants';

export const getUI = state => state.getIn([NAME, 'ui']);
export const getApp = state => state.getIn([NAME, 'app']);

export const getIsAuthenticated = createSelector(getApp, app =>
  app.get('isAuthenticated')
);
export const getIsAuthenticating = createSelector(getApp, app =>
  app.get('isAuthenticating')
);



// WEBPACK FOOTER //
// ./src/modules/auth/selectors.js